const StatCard = ({ value, label }) => (
  <div className="bg-white border border-[#E3E3E3] rounded-[10px] p-5 flex-1 min-w-0">
    <div className="text-4xl font-bold text-black">{value}</div>
    <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mt-2">{label}</div>
  </div>
);

export default StatCard;
